import React, { useEffect, useRef } from 'react';
import { wechatGenerateScheme } from "../../api";
import './style.scss';

// 川航·金熊猫俱乐部 → 直升八大洲 Club8 金卡 匹配落地页
// 小程序中转页（乱码路由，内部固定商户 AfrRo4oUBx3R + 金卡，无需带参）
const MINI_PATH = "/pages/subject/p5w8n2vb/p5w8n2vb";

// 6 张切图，从上到下拼接；第 2 张（index 1）含「点击立即匹配」按钮
const imgs = [
  "https://staticfile.badazhou.com/20260909/e964378b05e3b4cd2455ff2ed14aa2df.jpg", // _01 (压缩)
  "https://staticfile.badazhou.com/20260909/23a4332a2bcbc528d59217ac9119c7dd.jpg", // _02 含按钮 (压缩)
  "https://staticfile.badazhou.com/20260909/e05a5550cc39f9ba9ffa9247e513da18.jpg", // _03 (压缩)
  "https://staticfile.badazhou.com/20260909/a8a2067f160341222f20287a90f5d1fc.jpg", // _04 (压缩)
  "https://staticfile.badazhou.com/20260909/124b46dce4dcabb09c0f07ef5ed9d1f3.jpg", // _05 (压缩)
  "https://staticfile.badazhou.com/20260910/14956726312479fe5512cfeb01c0d9bb.jpeg", // _06 (换新图)
];

const BTN_INDEX = 1; // 「点击立即匹配」按钮所在切图下标

const Cpk9z3x7 = () => {
  const schemeRef = useRef();

  useEffect(() => {
    // 提前生成跳小程序的 URL Scheme
    const randomNum = parseInt(Math.random() * 100000000, 10);
    wechatGenerateScheme({ path: MINI_PATH, query: `randomNum=${randomNum}` })
      .then((res) => { schemeRef.current = res.data; })
      .catch(() => {});
  }, []);

  const goToWxApp = () => {
    const scheme = schemeRef.current && schemeRef.current.scheme;
    if (scheme) {
      window.location.href = scheme;
    }
  };

  return (
    <div className="cp-container">
      {imgs.map((src, i) => (
        <img
          key={i}
          className="cp-img"
          src={src}
          alt=""
          onClick={i === BTN_INDEX ? goToWxApp : undefined}
          style={i === BTN_INDEX ? { cursor: 'pointer' } : undefined}
        />
      ))}
    </div>
  );
};

export default Cpk9z3x7;
